import Bundle from "@framework/Bundle";

export const routes = require.context(
	"./",
	true,
	/.*\/@module($|\/routes\.(js))/
);

/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-START */
/* REMOVE-FOR-CLIENT-SSR-START */
export const controllers = [{value: () => import(/* webpackPreload: true */ "./@module/controller.js"), path: "./@module/controller.js"}, {value: () => import(/* webpackPreload: true */ "./Disputes/@module/controller.js"), path: "./Disputes/@module/controller.js"}, {value: () => import(/* webpackPreload: true */ "./PaymentsSettings/@module/controller.js"), path: "./PaymentsSettings/@module/controller.js"}];
export const models = [];
/* REMOVE-FOR-CLIENT-SSR-END */
export const libs = [];
export const styles = [{value: () => import(/* webpackPreload: true */ "./@styles/Disputes.styles.js"), path: "./@styles/Disputes.styles.js"}, {value: () => import(/* webpackPreload: true */ "./@styles/Payments.styles.js"), path: "./@styles/Payments.styles.js"}, {value: () => import(/* webpackPreload: true */ "./@styles/PaymentSetup.styles.js"), path: "./@styles/PaymentSetup.styles.js"}];
export const constants = [];
export const loadable = require.context("./", true, /\.(loadable)\.(js)$/);
export const stores = [];
export const extensions = [];
export const background = require.context("./", true, /\.(background)\.(js)$/);
/* webpack-strip-block:removed */
/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-END */
